<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Integrations</h4>
            <p class="category">Select a payment method</p>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-table v-model="stripe_status">
                  <md-table-row
                      slot="md-table-row"
                      class="items-center "
                  >
                    <md-table-cell>
                      <md-chip v-if="stripe_status.verified" class="md-primary">Connected</md-chip>
                      <md-chip v-else>Not connected</md-chip>
                    </md-table-cell>
                    <md-table-cell>
                      <img class="table_logo" src="@/assets/icons/stripe.svg" alt="">
                    </md-table-cell>
                    <md-table-cell class="flex justify-end w-25">
                      <md-button v-if="stripe_status.verified" disabled class="md-raised md-danger">
                        Disconnect
                      </md-button>
                      <md-button v-else class="md-raised md-success" @click="goToUrl">
                        Connect
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
<!--              <div class="md-layout-item md-size-100 text-right">-->
<!--                <md-button class="md-raised md-success">Save</md-button>-->
<!--              </div>-->
            </div>
          </md-card-content>
        </md-card>

      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "Integrations",
  data() {
    return {
      stripe_status: {},
      onboarding_url: ''
    }
  },
  mounted() {
    this.getStrStatus()
    this.getConnection()
    this.getUrl()
  },
  methods: {
    ...mapActions(['getStripeStatus', 'getStripeConnection']),
    goToUrl() {
      if(this.onboarding_url) {
        window.location.href = this.onboarding_url;
      }
    },
    getUrl() {
      if(this.$route.query.message) {
        this.getStrStatus()
      }
    },
    getStrStatus() {
      this.getStripeStatus()
      .then(res => {
        this.stripe_status = res.data
      })
    },
    getConnection() {
      this.getStripeConnection()
      .then(res => {
        this.onboarding_url = res.data.onboarding_url
      })
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  & .table_logo {
    width: 100px;
    height: 50px;
  }
}
</style>
